__webpack_require__.p = "https://worker-mh281mkjv-restworld.vercel.app/_next/";